import React, { createContext, useState, useContext } from "react";
import translations from "./translations";

export const LanguageContext = createContext();

export const useLanguage = () => useContext(LanguageContext);

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState("it");

  const t = (key, params = {}) => {
    let translation =
      translations[language] && translations[language][key]
        ? translations[language][key]
        : key;

    Object.keys(params).forEach((param) => {
      const regex = new RegExp(`\\{${param}\\}`, "g");
      translation = translation.replace(regex, params[param]);
    });

    return translation;
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};
